import { DEFAULT_PAGE_SIZE } from 'components/common/DataGridDevEx/DataGrid.constants';
import { fetchPost, objectify } from '../utils'
import moment from 'moment';
export const fetch = (query) => {
  const { CustomerId, filters, Page, Sort, SortDirection, BatchSize = DEFAULT_PAGE_SIZE } = query
  const respType = 'Inline';

  const From = filters && filters.FromDate && moment(filters.FromDate, 'DD/MM/YYYY').format('YYYY-MM-DD');
  const To = filters && filters.ToDate && moment(filters.ToDate, 'DD/MM/YYYY').format('YYYY-MM-DD');

  return fetchPost(
    `/CustomerEnquiry/Customer/${CustomerId}/Enquiries`,
    filters && { ...filters, FromDate: From, ToDate: To, Product: filters.Product || 0, },
    { BatchSize, BatchPage: Page, Sort: Sort && SortDirection && `${Sort}:${SortDirection}` },
    respType
  )
    .then(
      (result) => {
        if (result)
          if (result.Enquiries)
            return {
              records: result.Enquiries.map(item => objectify(item, null, 'Inline')),
              nextPage: result.BatchInformation && !result.BatchInformation.EndOfData,
              currPage: result.BatchInformation && result.BatchInformation.BatchPage,
            }
          else
            return result

      })
}
